"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_DATE = "1000-01-01";
exports.MAX_DATE = "9999-12-30";
//# sourceMappingURL=NoticeSettingsModel.js.map